import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import React, { useRef, useState } from "react";
import { Modal, Text, TextInput, TouchableOpacity, View } from "react-native";
import ModalPaperWalletDeposit from "../../components/ModalPaperWalletDeposit";
import paperWalletService from "../../services/paperWalletService";
import toast from "../../utils/toast";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";
import { If, Then, Else } from "react-if";

const PaperWalletDeposit = ({ navigation, route }) => {
  const ref = useRef(null);
  const isFocused = useIsFocused();

  const [modalVisible, setModalVisible] = useState(false);
  const [code, setCode] = useState("");
  const [validationCode, setValidationCode] = useState(0);

  const deposit = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    paperWalletService
      .deposit(token, code, {
        validation_code: validationCode,
      })
      .then((response) => {

        if (response.data && response.data.success) {
          setModalVisible(true);
        } else {
          if (response?.data?.message) {
            toast(response?.data?.message, "#DA1414");
          } else {
            toast(
              intl.formatMessage({
                id: "paperWalletDeposit.erroProblemaDeposito",
              }),
              "#DA1414"
            );
          }
        }
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          toast(error.response?.data?.message, "#DA1414");
        } else {
          toast(
            intl.formatMessage({
              id: "paperWalletDeposit.erroProblemaDeposito",
            }),
            "#DA1414"
          );
        }
      });
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="paperWalletDeposit.titlePaperWallet" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="paperWalletDeposit.depositePaperWallet" />
          </Text>
        }
      />

      <View style={styles.container}>
        <View style={styles.view}>
          <Text style={styles.label}>
            <FormattedMessage id="paperWalletDeposit.txtDigiteCodigoPaperWallet" />
          </Text>

          <FormattedMessage id="paperWalletDeposit.txtInputPlaceholderCodigo">
            {(placeholder) => (
              <TextInput
                value={code}
                placeholder={placeholder}
                style={styles.input}
                autoCapitalize="none"
                keyboardType="numeric"
                onChangeText={(val) => setCode(val.replace(/[^0-9]/g, ""))}
              ></TextInput>
            )}
          </FormattedMessage>

          <Text style={styles.label}>
            <FormattedMessage id="paperWalletDeposit.txtDigiteSenha" />
          </Text>

          <FormattedMessage id="paperWalletDeposit.placeholderDigiteSenha">
            {(placeholder) => (
              <TextInput
                value={validationCode}
                placeholder={placeholder}
                style={styles.input}
                autoCapitalize="none"
                maxLength={10}
                onChangeText={(val) => setValidationCode(val.toUpperCase())}
              ></TextInput>
            )}
          </FormattedMessage>

          <TouchableOpacity
            style={[
              styles.action_button,
              !code || !validationCode ? styles.disabled_button : null,
            ]}
            onPress={() => {
              if (code && validationCode) {
                deposit();
              }
            }}
            activeOpacity={!code || !validationCode ? 1 : 0.7}
            disabled={!code || !validationCode}
          >
            <Text style={styles.action_button_text}>
              <FormattedMessage id="paperWalletDeposit.txtDepositarPaperWallet" />
            </Text>
          </TouchableOpacity>

          <GoBackButton style={{ maxWidth: 320, marginTop: 12 }} />
        </View>
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => navigation.navigate("Tabs")}
      >
        <ModalPaperWalletDeposit
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate("Tabs");
          }}
          handleCloseWithTransaction={() => {
            setModalVisible(false);
            navigation.navigate({
              name: "Tabs",
              params: { openTransaction: false },
            });
          }}
        />
      </Modal>
    </>
  );
};

export default PaperWalletDeposit;
